import type {Environment} from 'react-relay'
import {RecordSource} from 'relay-runtime'

import type {CommitComment} from '../types/commit-types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type RecordMap = Record<string, any>

/**
 * For compatibility with the relay components, put already loaded commit comment data into the relay store.
 * Then (ideally without a network request) the relay components will read from this store and use that as data.
 * @param environment the relay environment
 * @param comment the commit comment whose data will be set in the record map
 */
export const setRecordMap = (environment: Environment, comment: CommitComment) => {
  if (environment.getStore().getSource().has(comment.relayId)) return

  const recordMap: RecordMap = {}

  const lastEdit = comment.lastUserContentEdit

  recordMap[comment.relayId] = {
    __typename: 'CommitComment',
    __isComment: 'CommitComment',
    __id: comment.relayId, // important to have this for relay to work
    id: comment.relayId,
    viewerCanReadUserContentEdits: comment.viewerCanReadUserContentEdits,
    lastEditedAt: comment.updatedAt,
    lastUserContentEdit: lastEdit ? {__ref: lastEdit.relayId} : null,
  }

  recordMap['client:__type:CommitComment'] = {
    __id: 'client:__type:CommitComment',
    __typename: '__TypeSchema',
    __isComment: true,
  }

  if (lastEdit) {
    recordMap[lastEdit.relayId] = {
      __typename: 'UserContentEdit',
      __id: lastEdit.relayId, // important to have this for relay to work
      id: lastEdit.relayId,
      editor: lastEdit.editor ? {__ref: lastEdit.editor.relayId} : null,
    }

    if (lastEdit.editor) {
      recordMap[lastEdit.editor.relayId] = {
        __id: lastEdit.editor.relayId,
        __typename: 'User',
        id: lastEdit.editor.relayId,
        login: lastEdit.editor.login,
        url: lastEdit.editor.url,
      }
    }
  }

  environment.getStore().publish(new RecordSource(recordMap))
}
